import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'components/toggle';

export default function BetaToggleInput({ checked, label, onChange }) {
  return (
    <div className="d-flex align-items-center mt-3">
      <Toggle checked={checked} theme="buildout" onChange={onChange}/>
      <p className="m-0 ml-3">{label}</p>
    </div>
  );
}

BetaToggleInput.propTypes = {
  checked: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func
};
